import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "../../../services/auth.service";
import { BoxesService } from "../../../services/boxes-service";
import { Constants } from "../../../utils/constants";
import { SnackService } from "../../../services/snack.service";
import { SplitCamelCasePipe } from "../../../pipes/split-camel-case.pipe";
import { DialogsService } from "../../../services/dialogs.service";
import { BoxAndTestbed } from '../../../model/box-and-testbed';


@Component({
  selector: 'aw-box-card-researcher',
  templateUrl: './box-card-researcher-dashboard.component.html',
  styleUrls: ['./box-card-researcher-dashboard.component.scss']
})
export class BoxCardResearcherDashboardComponent implements OnInit {

  boxAndTestbed?: BoxAndTestbed;
  contractStatus = Constants.contractStatuses;
  roles = Constants.roles;
  loading = false;
  disabled = false;
  loggedUser: any;
  showDocs = false;

  constructor(
    public dialog: MatDialog,
    public dialogsService: DialogsService,
    public boxesService: BoxesService,
    public authService: AuthService,
    public snackService: SnackService,
    public splitCamelCase: SplitCamelCasePipe,
  ) {
  }

  @Input() set element(element: BoxAndTestbed) {
    this.boxAndTestbed = element;
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }


}
